// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1c7aw","title":"Images90_title__1ydS4","images":"Images90_images__EWNiL"};